export class AdlModel {
    length:string = null;
    weight:string = null;
    adlMobility:string = null;
    heartLungProblems:string = null;
    repatriationQuestion:string = null;
    cast:string = null;
    covid:string = null;
    adlOtherActivities:string = null;
    homeSituation:string = null;
    lastModifiedDate:Date = null;
    lastModifiedBy:string = null;
    createdDate:Date = null;
    dadDossierId:string = null;
    dadId:string = null;
}


